import { Browser } from "@/utils/browser";
import { fonsBrand } from "./fons";
import { studioBrand } from "./studio";
import { Brand, BrandId } from "./types";

export type { Brand, BrandId } from "./types";

export function getBrandFromHost(hostname: string): BrandId {
  if (hostname.endsWith("fons.app")) return "fons";
  return "studio";
}

function resolveBrand(): Brand {
  const hostname = Browser.getLocation()?.hostname ?? "";
  const brandId = getBrandFromHost(hostname);
  return brandId === "studio" ? studioBrand : fonsBrand;
}

export const brand: Brand = resolveBrand();
